import { Flex } from 'antd';
import EmptyImage from '@/assets/images/dashboard/empty-report.png';
import { CustomShipmentText } from '@/components';

interface TableSectionEmptyStateProps {
  /** A search is applied, so an empty table means "no matches", not "no columns". */
  hasActiveSearch?: boolean;
}

const TableSectionEmptyState = ({
  hasActiveSearch = false,
}: TableSectionEmptyStateProps) => {
  return (
    <>
      <Flex align='center' vertical gap={12}>
        <img src={EmptyImage} alt='' />
        <CustomShipmentText
          text={hasActiveSearch ? 'No Data Found' : 'No columns selected'}
          lineHeight='32px'
          fontSize='24px'
          fontWeight={700}
        />
        <CustomShipmentText
          text={
            hasActiveSearch
              ? 'No records match your search. Try a different search term.'
              : 'Choose at least one to enable download'
          }
          lineHeight='20px'
          fontSize='14px'
        />
      </Flex>
    </>
  );
};

export default TableSectionEmptyState;
